package com.ervasstudio.tracoemovimento.pages.cursos.signup

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.components.custumcomponents.layout.GoogleLoginButton
import com.ervasstudio.tracoemovimento.model.EtapasDeCadastro
import com.ervasstudio.tracoemovimento.model.GoogleUser
import com.ervasstudio.tracoemovimento.util.Res
import com.ervasstudio.tracoemovimento.util.Res.MyColors.PretoDesfalecido
import com.ervasstudio.tracoemovimento.util.Res.MyColors.SurfaceContent
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

@Composable
fun SignUpPage(
    jaTenhoContaClick: () -> Unit,
    nome: String,
    sobrenome: String,
    email: String,
    onNomeChange: (String) -> Unit,
    onSobrenomeChange: (String) -> Unit,
    onEmailChange: (String) -> Unit,
    externalError: String? = null,
    onContinuarClicked: () -> Unit,
    etapa: EtapasDeCadastro,
    errorMessage: String? = null,
    senha: String,
    repeticaoSenha: String,
    onSenhaChange: (senha: String) -> Unit,
    onRepeticaoSenhaChange: (repeticaoSenha: String) -> Unit,
    onCadastrarClick: () -> Unit,
    onGoogleLoginButtonClick: (GoogleUser) -> Unit,
    isMobile: Boolean,
) {
    if (isMobile) {
        SignUpMobile(
            jaTenhoContaClick, nome, sobrenome, email, onNomeChange, onSobrenomeChange,
            onEmailChange, externalError, onContinuarClicked, etapa, senha, repeticaoSenha,
            onSenhaChange, onRepeticaoSenhaChange, onCadastrarClick, onGoogleLoginButtonClick,
        )
    } else {
        SignUpDesktop(
            jaTenhoContaClick, nome, sobrenome, email, onNomeChange, onSobrenomeChange,
            onEmailChange, externalError, onContinuarClicked, etapa, senha, repeticaoSenha,
            onSenhaChange, onRepeticaoSenhaChange, onCadastrarClick, onGoogleLoginButtonClick,
        )
    }
}

@Composable
private fun SignUpDesktop(
    jaTenhoContaClick: () -> Unit,
    nome: String,
    sobrenome: String,
    email: String,
    onNomeChange: (String) -> Unit,
    onSobrenomeChange: (String) -> Unit,
    onEmailChange: (String) -> Unit,
    externalError: String?,
    onContinuarClicked: () -> Unit,
    etapa: EtapasDeCadastro,
    senha: String,
    repeticaoSenha: String,
    onSenhaChange: (String) -> Unit,
    onRepeticaoSenhaChange: (String) -> Unit,
    onCadastrarClick: () -> Unit,
    onGoogleLoginButtonClick: (GoogleUser) -> Unit,
) {
    Row(
        modifier = Modifier.fillMaxWidth().minHeight(100.vh).gap(10.cssRem),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center,
    ) {
        Column(
            modifier = Modifier.weight(1f).fillMaxHeight(),
            horizontalAlignment = Alignment.End,
            verticalArrangement = Arrangement.Center
        ) {
            Image(
                src = Res.Image.tracoemovultra,
                alt = "Traço Movimento",
                modifier = Modifier.width(320.px)
            )
        }

        Column(
            modifier = Modifier.weight(1f).fillMaxHeight(),
            horizontalAlignment = Alignment.Start,
            verticalArrangement = Arrangement.Center
        ) {
            SignUpFormContent(
                jaTenhoContaClick, nome, sobrenome, email, onNomeChange, onSobrenomeChange,
                onEmailChange, externalError, onContinuarClicked, etapa, senha, repeticaoSenha,
                onSenhaChange, onRepeticaoSenhaChange, onCadastrarClick, onGoogleLoginButtonClick,
                isMobile = false,
            )
        }
    }
}

@Composable
private fun SignUpMobile(
    jaTenhoContaClick: () -> Unit,
    nome: String,
    sobrenome: String,
    email: String,
    onNomeChange: (String) -> Unit,
    onSobrenomeChange: (String) -> Unit,
    onEmailChange: (String) -> Unit,
    externalError: String?,
    onContinuarClicked: () -> Unit,
    etapa: EtapasDeCadastro,
    senha: String,
    repeticaoSenha: String,
    onSenhaChange: (String) -> Unit,
    onRepeticaoSenhaChange: (String) -> Unit,
    onCadastrarClick: () -> Unit,
    onGoogleLoginButtonClick: (GoogleUser) -> Unit,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .minHeight(100.vh)
            .padding(leftRight = 20.px, topBottom = 24.px),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center,
    ) {
        Image(
            src = Res.Image.tracoemovultra,
            alt = "Traço Movimento",
            modifier = Modifier.width(140.px)   // era 320.px
                .margin(bottom = 24.px)
        )

        SignUpFormContent(
            jaTenhoContaClick, nome, sobrenome, email, onNomeChange, onSobrenomeChange,
            onEmailChange, externalError, onContinuarClicked, etapa, senha, repeticaoSenha,
            onSenhaChange, onRepeticaoSenhaChange, onCadastrarClick, onGoogleLoginButtonClick,
            isMobile = true,
        )
    }
}

@Composable
private fun SignUpFormContent(
    jaTenhoContaClick: () -> Unit,
    nome: String,
    sobrenome: String,
    email: String,
    onNomeChange: (String) -> Unit,
    onSobrenomeChange: (String) -> Unit,
    onEmailChange: (String) -> Unit,
    externalError: String?,
    onContinuarClicked: () -> Unit,
    etapa: EtapasDeCadastro,
    senha: String,
    repeticaoSenha: String,
    onSenhaChange: (String) -> Unit,
    onRepeticaoSenhaChange: (String) -> Unit,
    onCadastrarClick: () -> Unit,
    onGoogleLoginButtonClick: (GoogleUser) -> Unit,
    isMobile: Boolean,
) {
    Column(
        modifier = if (isMobile) Modifier.fillMaxWidth() else Modifier.width(320.px),   // era width(320.px) sempre
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SpanText(
            text = "Se cadastrar",
            modifier = Modifier
                .fontFamily("GothamBlack")
                .fontSize(if (isMobile) 19.px else 22.px)   // era 22.px
                .color(PretoDesfalecido)
                .margin(bottom = if (isMobile) 0.6.cssRem else 1.cssRem)
        )
        SpanText(
            text = "para continuares na tua conta.",
            modifier = Modifier
                .fontFamily("GothamBook")
                .fontSize(if (isMobile) 14.px else 16.px)   // era 16.px
                .color(PretoDesfalecido)
                .margin(bottom = if (isMobile) 18.px else 24.px)
        )

        when (etapa) {
            EtapasDeCadastro.PrimeitaEtapa -> {
                PrimeiraEtapaSignUp(
                    nome = nome,
                    sobrenome = sobrenome,
                    email = email,
                    onNomeChange = onNomeChange,
                    onSobrenomeChange = onSobrenomeChange,
                    onEmailChange = onEmailChange,
                    externalError = externalError,
                    onContinuarClick = onContinuarClicked,
                    isMobile = isMobile,
                )
            }
            EtapasDeCadastro.SegundaEtapa -> {
                SegundaEtapaSignUp(
                    senha = senha,
                    repeticaoSenha = repeticaoSenha,
                    onSenhaChange = onSenhaChange,
                    onRepeticaoSenhaChange = onRepeticaoSenhaChange,
                    onCadastrarClick = onCadastrarClick,
                    isMobile = isMobile,
                )
            }
        }

        Row(
            modifier = Modifier.fillMaxWidth().margin(topBottom = if (isMobile) 16.px else 24.px),   // era 24.px
            verticalAlignment = Alignment.CenterVertically
        ) {
            Box(Modifier.weight(1f).height(1.px).backgroundColor(Colors.LightGray))
            SpanText(
                text = "Outras opções de inscrição",
                modifier = Modifier.padding(leftRight = 8.px).fontSize(if (isMobile) 11.px else 12.px).color(Colors.Gray)
            )
            Box(Modifier.weight(1f).height(1.px).backgroundColor(Colors.LightGray))
        }

        GoogleLoginButton(onSuccess = onGoogleLoginButtonClick, onError = {})

        SpanText(
            text = "Ao se inscrever, você concorda com nossos Termos de Uso e com a Política de Privacidade.",
            modifier = Modifier
                .textAlign(TextAlign.Center)
                .fontFamily("GothamBook")
                .fontSize(if (isMobile) 11.px else 12.px)   // era 12.px
                .margin(top = if (isMobile) 12.px else 0.px, bottom = if (isMobile) 12.px else 16.px)
        )

        Button(
            onClick = { jaTenhoContaClick() },
            modifier = Modifier
                .fillMaxWidth()
                .height(if (isMobile) 40.px else 44.px)   // era 44.px
                .borderRadius(24.px)
                .backgroundColor(color = SurfaceContent)
                .styleModifier { property("border", "none") }
        ) {
            SpanText(
                "Já tem uma conta? Fazer login",
                Modifier.fontFamily("GothamBook").fontWeight(FontWeight.Bold).fontSize(if (isMobile) 12.px else 13.px)   // era 13.px
            )
        }
    }
}





private fun inputModifier() = Modifier
    .fillMaxWidth()
    .height(48.px)
    .borderRadius(24.px)
    .border(1.px, LineStyle.Solid, Colors.Black)
    .padding(leftRight = 16.px)
    .margin(bottom = 12.px)
    .styleModifier { property("outline", "none")
    }